import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
// import "./LeaveManagement.css"; // Import your CSS styles

const ManageLeaves = ({
  applyLeaves,
  leaveTypes,
  addPage,
  deletePage,
  pageSave,
}) => {
  const [modalData, setModalData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [delId, setDelId] = useState(0);
  const [status, setStatus] = useState("");

  const handleDelete = (id) => {
    setDelId(id);
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Perform the delete action here
        // You can use an API call to delete the record
        console.log(`Deleting record with ID: ${id}`);
        // After deletion, you might want to refresh the list or update the state
      } else {
        Swal.fire("Cancelled", "Your record is safe :)", "error");
      }
    });
  };

  const handleModalOpen = (data) => {
    setModalData(data);
    setStatus(data.status);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setModalData(null);
  };

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Perform save action here
    console.log({ ...modalData, status });
    // You can use an API call to save the status
    Swal.fire("Success", "Leave status updated successfully!", "success").then(
      () => {
        handleModalClose(); // Close the modal after submission
      }
    );
  };

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="row">
            <div className="col-md-12">
              <div className="panel-heading border-0">
                <h4 className="panel-title pull-left">Manage Leaves</h4>
                {addPage && (
                  <button
                    className="btn btn-default btn-sm pull-right"
                    onClick={() => (window.location.href = addPage)}
                  >
                    <FontAwesomeIcon icon={faPlus} /> Apply Leave
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {applyLeaves && applyLeaves.length > 0 ? (
                <div className="table-responsive">
                  <table className="table m-b-0">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>#</th>
                        <th>User</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Leave Type</th>
                        <th>Reason</th>
                        <th>Status</th>
                        <th style={{ width: "1%" }} colSpan="2">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {applyLeaves.map((leave, index) => (
                        <tr key={leave.id}>
                          <td
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td>{leave.user_fullname}</td>
                          <td>{leave.start_date}</td>
                          <td>{leave.end_date}</td>
                          <td>{leave.type}</td>
                          <td>{leave.reason}</td>
                          <td>{leave.status}</td>
                          <td>
                            {leave.status === "Pending" && (
                              <button
                                className="btn btn-warning btn-xs leaveModal"
                                onClick={() => handleModalOpen(leave)}
                              >
                                <FontAwesomeIcon icon={faPlus} />
                              </button>
                            )}
                          </td>
                          <td>
                            {leave.status === "Pending" && (
                              <button
                                className="cancel btn btn-danger btn-xs"
                                onClick={() => handleDelete(leave.id)}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div>No records found.</div>
              )}
            </div>
          </div>
        </div>
        {showModal && (
          <div className="modal" id="leaveModal">
            <div className="modal-dialog modal-sm">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Leave Details</h4>
                  <button
                    type="button"
                    className="close"
                    onClick={handleModalClose}
                  >
                    &times;
                  </button>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="modal-body">
                    <div className="form-group">
                      <p>
                        <b>User Name: </b>
                        <span>{modalData.user_fullname}</span>
                      </p>
                    </div>
                    <div className="form-group">
                      <p>
                        <b>Start Date: </b>
                        <span>{modalData.start_date}</span>
                      </p>
                    </div>
                    <div className="form-group">
                      <p>
                        <b>End Date: </b>
                        <span>{modalData.end_date}</span>
                      </p>
                    </div>
                    <div className="form-group">
                      <p>
                        <b>Leave Type: </b>
                        <span>{modalData.type}</span>
                      </p>
                    </div>
                    <div className="form-group">
                      <p>
                        <b>Reason: </b>
                        <span>{modalData.reason}</span>
                      </p>
                    </div>
                    <div className="form-group">
                      <label className="form_control">Status</label>
                      <select
                        name="status"
                        className="form-control"
                        value={status}
                        onChange={handleStatusChange}
                      >
                        <option value="">- Select -</option>
                        <option value="Pending">Pending</option>
                        <option value="Reject">Reject</option>
                        <option value="Approved">Approved</option>
                      </select>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <input type="hidden" name="id" value={modalData.id} />
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
        <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </a>
      </div>
    </div>
  );
};

export default ManageLeaves;
